import { IServiceItem } from './types';
import StocksIcon from '../assets/stocks.svg';
import CalculatorIcon from '../assets/calculator.svg';
import CheckIcon from '../assets/check.svg';
import InterestIcon from '../assets/interest.svg';
import PrivilegesIcon from '../assets/privileges.svg';
import RealtorIcon from '../assets/realtor.svg';
import SelectionIcon from '../assets/selection.svg';
import MagazineIcon from '../assets/magazine.svg';
import GuidesIcon from '../assets/guides.svg';

export const saleServices: IServiceItem[] = [
  {
    title: 'Новостройки',
    children: [
      {
        title: 'Посмотрите акции и скидки',
        description: 'Если хотите выгодно купить квартиру в новостройке',
        link: 'https://www.cian.ru/skidki-i-akcii/',
        icon: StocksIcon,
        eventLabel: 'Stocks',
      },
      {
        title: 'Подберите новостройку',
        description: 'Если решили купить новую квартиру, а искать некогда',
        link: 'https://www.cian.ru/podobrat-kvartiru-v-novostrojke/',
        icon: SelectionIcon,
        eventLabel: 'Select_newbuilding',
      },
    ],
  },
  {
    title: 'Ипотека',
    children: [
      {
        title: 'Выберите ипотеку',
        description: 'Если денег с продажи не хватит на покупку новой квартиры',
        link: 'https://www.cian.ru/ipoteka-main/',
        icon: InterestIcon,
        eventLabel: 'Select_mortgage',
      },
      {
        title: 'Посчитайте платёж по ипотеке',
        description: 'Если денег с продажи не хватит на покупку новой квартиры',
        link: 'https://www.cian.ru/ipoteka/calculator',
        icon: CalculatorIcon,
        eventLabel: 'Calculation_payment',
      },
      {
        title: 'Изучите льготы по ипотеке',
        description: 'Если не хватает на покупку новой квартиры',
        link: 'https://www.cian.ru/ipoteka/',
        icon: PrivilegesIcon,
        eventLabel: 'Privileges',
      },
    ],
  },
  {
    title: 'Информационные',
    children: [
      {
        title: 'Почитайте советы экспертов',
        description: 'Если даже не знаете, с чего начать',
        link: 'https://www.cian.ru/magazine/',
        icon: MagazineIcon,
        eventLabel: 'Expert_advice',
      },
      {
        title: 'Посмотрите гайды по продаже',
        description: 'Они созданы специально для собственников',
        link: 'https://www.cian.ru/guide/prodat-kvartiru-vtorichka/?step=main',
        icon: GuidesIcon,
        eventLabel: 'Guides',
      },
    ],
  },
  {
    title: 'Проверьте недвижимость',
    description: 'Если нашли новую квартиру, и она выглядит подозрительно',
    link: 'https://www.cian.ru/legal-check/',
    icon: CheckIcon,
    eventLabel: 'Flat_check',
  },
  {
    title: 'Подберите риелтора',
    description: 'Если сами не готовы общаться и показывать квартиру',
    link: 'https://www.cian.ru/podbor-rieltora/',
    icon: RealtorIcon,
    eventLabel: 'Select_realtor',
  },
];

export const rentServices: IServiceItem[] = [
  {
    title: 'Подберите риелтора',
    description: 'Если сами не готовы общаться и показывать квартиру',
    link: 'https://www.cian.ru/podbor-rieltora/',
    icon: RealtorIcon,
    eventLabel: 'Select_realtor',
  },
  {
    title: 'Почитайте советы экспертов',
    description: 'Если даже не знаете, с чего начать',
    link: 'https://www.cian.ru/magazine/',
    icon: MagazineIcon,
    eventLabel: 'Expert_advice',
  },
];

export const SALE_SERVICES_TEST_ID = 'other_services_for_sale';
export const RENT_SERVICES_TEST_ID = 'other_services_for_rent';
export const SALE_HEADING_TITLE = 'Если хотите продать квартиру';
export const RENT_HEADING_TITLE = 'Если хотите сдать квартиру';
